export const BASE_URI = "https://codeable-github-stats-api.herokuapp.com";
export const tokenKey = "github-collection-token";